function FixGetTime(aValue, aTimeZoneId) {
    "use strict";
    var lResult = 5,
        lTimeZone = getTimezone(aTimeZoneId),
        lValue = displayFixedTimeZoneTime(aValue, lTimeZone.TimeZoneName),
        lUTCDay = getTimeZoneUTCDday(lValue, lTimeZone.TimeZoneName),
        lDay = lValue.getDay();

    if ((lDay == 0 && lUTCDay == 6) || (lDay == 1 && lUTCDay == 0)) {
        lResult = 0;
    }
    else if ((lDay == 6 && lUTCDay == 0) || (lDay == 0 && lUTCDay == 1)) {
        lResult = 1;
    }
    else {
        if (lDay < lUTCDay) {
            lResult = 1;
        }
        else if (lDay > lUTCDay) {
            lResult = 0;
        }
    }
    return lResult;
}
if (typeof exports !== 'undefined') {
    module.exports = FixGetTime;
}